import EsamiSpecialisticiEdit from "./components/EsamiSpecialisticiEdit.vue";
import EsamiSpecialisticiView from "./components/EsamiSpecialisticiView.vue";
import EsamiSpecialisticiList from "./components/EsamiSpecialisticiList.vue";

export default {
    EsamiSpecialisticiEdit,
    EsamiSpecialisticiView,
    EsamiSpecialisticiList,
};
